export const notFound = (entity, id) => ({ kind: "NotFound", entity, id });
export const permissionDenied = (action) => ({ kind: "PermissionDenied", action });
export const conflict = (detail) => ({ kind: "Conflict", detail });
export const corrupt = (detail) => ({ kind: "Corrupt", detail });
export const networkError = (cause) => ({ kind: "Network", cause });
export const inviteInvalid = () => ({ kind: "InviteInvalid" });
export const validation = (details) => ({ kind: "Validation", details });
//# sourceMappingURL=domainError.js.map